// PasswordInput.jsx
import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";

const CheckoutPasswordInput = ({ label, name, required = false }) => {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	const fadeUpVariants = {
		hidden: { opacity: 0, y: 10 },
		visible: { opacity: 1, y: 0 },
	};

	return (
		<div className="flex flex-col gap-2 text-xs">
			{/* Field Label */}
			<div className="flex w-full justify-between">
				<label htmlFor={name} className="flex items-center gap-1">
					<span className="text-sm uppercase text-neutral-50">{label}</span>{" "}
					{required && (
						<span className="text-ipxon-magenta flex gap-0.5 text-[10px] font-bold uppercase">*</span>
					)}
				</label>
				{/* Toggle Button */}
				<AnimatePresence>
					<motion.button
						type="button"
						onClick={togglePasswordVisibility}
						className="text-neutral-400 hover:text-neutral-200 focus:outline-none"
						aria-label={showPassword ? "Hide password" : "Show password"}
					>
						{showPassword ? (
							<motion.span
								variants={fadeUpVariants}
								initial="hidden"
								animate="visible"
								transition={{ duration: 0.3 }}
							>
								<FaEyeSlash className="h-4 w-4" />
							</motion.span>
						) : (
							<motion.span
								variants={fadeUpVariants}
								initial="hidden"
								animate="visible"
								transition={{ duration: 0.3 }}
							>
								<FaEye className="h-4 w-4" />
							</motion.span>
						)}
					</motion.button>
				</AnimatePresence>
			</div>

			{/* Password Field with Toggle */}
			<Field
				id={name}
				name={name}
				type={showPassword ? "text" : "password"}
				className="
            w-full
            rounded-lg
            border 
            border-neutral-50
            bg-transparent 
            px-3 py-3
            text-neutral-50
            placeholder-neutral-500
            focus:outline-none
            focus:border-white
            focus:ring-0
            focus:ring-offset-0
            text-xs
          "
			/>

			{/* Error Message */}
			{/* <ErrorMessage name={name}>{(msg) => <div className="text-red-500 text-xs">{msg}</div>}</ErrorMessage> */}
		</div>
	);
};

export default CheckoutPasswordInput;
